var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFabricRoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 96,
    viewBox: "0 0 115 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1298_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3671 5.18041L17.9187 4.34384C17.638 4.20121 17.2793 4.22452 16.8891 4.45081C15.9869 4.97195 15.2559 6.37355 15.2559 7.57903C15.2559 8.17835 15.4352 8.61446 15.7282 8.84075H15.7268L15.7282 8.84212L17.2588 9.71435L19.3671 5.18041Z",
    fill: "#5B8745"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9371 6.49747C19.9371 7.70295 19.2047 9.10455 18.3011 9.62707C17.3989 10.1482 16.6678 9.59415 16.6678 8.38867C16.6678 7.18318 17.3989 5.78158 18.3011 5.25907C19.2047 4.73792 19.9371 5.29198 19.9371 6.49747Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7159 38.5511L6.22731 46.9305L14.6401 15.5947L21.7455 11.4846L28.18 7.76388L36.5928 29.368L20.7159 38.5511ZM29.2273 4.77417L20.7159 9.69897L12.8727 14.2329L2.94434 51.2121L39.1556 30.269L29.2273 4.77417Z",
    fill: "#4F783A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4882 37.327L3.99953 45.7064L12.4123 14.3692L19.5177 10.2591L25.9522 6.53839L34.3664 28.1439L18.4882 37.327ZM26.9995 3.55005L18.4882 8.47348L10.6449 13.0088L0.716553 49.9866L36.9279 29.0449L26.9995 3.55005Z",
    fill: "#4F783A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.228 4.77336L27.0006 3.55005L10.6459 13.0088L12.8734 14.2321L29.228 4.77336Z",
    fill: "#71A258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5936 29.3672L34.3675 28.1439L7.01666 43.9908L6.22809 46.9297L36.5936 29.3672Z",
    fill: "#71A258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94399 51.2112L0.716553 49.9865L10.6449 13.0087L12.8723 14.232L2.94399 51.2112Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5937 29.3677L34.3677 28.1443L26.7516 8.58915L28.1809 7.76355L36.5937 29.3677Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5686 46.9568L6.48116 45.8528L80.8602 88.9815L78.9476 90.0251L4.5686 46.9568Z",
    fill: "#71A258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2056 89.5304L4.5686 46.9435V50.2514L78.2056 92.8383V89.5304Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1904 28.8213L38.103 27.7173L112.482 70.846L110.569 71.8896L36.1904 28.8213Z",
    fill: "#71A258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.827 71.3963L36.1904 28.808V32.1159L109.827 74.7042V71.3963Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1047 6.28869C18.9541 6.21601 18.7651 6.22561 18.5584 6.34492C18.0683 6.62881 17.6713 7.38721 17.6713 8.04138C17.6713 8.39521 17.7904 8.64069 17.9766 8.75041L26.8576 13.7836L27.9282 11.2821L19.1047 6.28869Z",
    fill: "#393A37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2217 1.33779L61.1767 15.9366L36.2217 1.33779C34.6363 0.561565 32.5951 0.693222 30.4073 1.95905C25.2898 4.91859 21.1403 12.8605 21.1403 19.6971C21.1403 23.378 22.345 25.9865 24.2562 27.1481L79.8108 59.3177L91.7421 33.5088C91.7421 33.5088 36.3846 1.42008 36.2217 1.33779Z",
    fill: "#E15F5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0524 41.0763C95.0524 47.9115 90.9028 55.8534 85.7853 58.813C80.6678 61.7725 76.5182 58.6306 76.5182 51.7954C76.5182 44.9588 80.6678 37.0182 85.7853 34.0573C90.9028 31.0978 95.0524 34.2397 95.0524 41.0763Z",
    fill: "#DE4748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3085 42.8015C93.3085 47.825 90.2596 53.6591 86.5002 55.8342C82.7394 58.0092 79.6906 55.6998 79.6906 50.6776C79.6906 45.6554 82.7394 39.82 86.5002 37.6449C90.2596 35.4698 93.3085 37.7793 93.3085 42.8015Z",
    fill: "#D63739"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.284 44.3787C91.284 47.6866 89.2756 51.528 86.799 52.9611C84.3237 54.3929 82.3153 52.872 82.3153 49.5654C82.3153 46.2576 84.3237 42.4148 86.799 40.983C89.2756 39.5499 91.284 41.0708 91.284 44.3787Z",
    fill: "#CA3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8582 28.6679L70.2488 53.8213C70.2488 53.8213 65.7488 49.648 64.3003 45.0647C62.6889 39.9657 60.2151 33.2375 53.8955 28.8078C51.601 27.2005 46.6464 24.6962 37.5423 26.1225C30.4643 27.2293 27.0143 28.6528 26.8582 28.6679Z",
    fill: "#DE4748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6912 25.2995C48.7925 24.2476 49.2662 23.5304 49.9041 23.6798C50.2834 23.7676 50.7009 24.2504 50.6777 25.6574C50.6297 28.2837 51.0199 30.1598 49.6002 29.8417C48.2654 29.5441 48.52 27.0906 48.6912 25.2995Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8322 82.1288L81.3436 90.5083L89.7577 59.1711L103.296 51.3403L111.712 72.9444L95.8322 82.1288ZM104.345 48.3519L87.9903 57.8107L78.062 94.7885L114.273 73.8468L104.345 48.3519Z",
    fill: "#4F783A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6039 80.9041L79.1153 89.2849L87.5295 57.9464L101.068 50.1155L109.484 71.721L93.6039 80.9041ZM102.117 47.1285L85.762 56.5873L75.8337 93.5651L112.045 72.622L102.117 47.1285Z",
    fill: "#4F783A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.344 48.3519L102.117 47.1285L85.7621 56.5873L87.9896 57.8106L104.344 48.3519Z",
    fill: "#71A258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.711 72.944L109.484 71.7207L82.1314 87.5689L81.3428 90.5079L111.711 72.944Z",
    fill: "#71A258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0611 94.7883L75.8337 93.565L85.762 56.5872L87.9895 57.8105L78.0611 94.7883Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.711 72.9442L109.483 71.7209L101.867 52.1671L103.295 51.3401L111.711 72.9442Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5402 45.8803C87.3841 45.8049 87.1897 45.8145 86.9748 45.9393C86.4696 46.2301 86.0603 47.0145 86.0603 47.6893C86.0603 48.0568 86.1835 48.3105 86.3752 48.423L95.9284 53.8154L97.0346 51.2317L87.5402 45.8803Z",
    fill: "#393A37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4163 52.0026C97.4163 52.6787 97.0069 53.4618 96.5018 53.7539C95.9966 54.046 95.5859 53.7361 95.5859 53.0613C95.5859 52.3866 95.9966 51.6021 96.5018 51.31C97.0069 51.0179 97.4163 51.3279 97.4163 52.0026Z",
    fill: "#8E8F8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0343 52.2577C97.0343 52.639 96.803 53.0833 96.5168 53.2479C96.2321 53.4138 95.9993 53.2383 95.9993 52.857C95.9993 52.4744 96.2321 52.0314 96.5168 51.8655C96.803 51.7009 97.0343 51.8765 97.0343 52.2577Z",
    fill: "#373835"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3295 50.6979L96.8838 49.8614C96.6018 49.7187 96.2445 49.7434 95.8543 49.9683C94.9493 50.4895 94.2183 51.8911 94.2183 53.0966C94.2183 53.6959 94.399 54.1334 94.692 54.3583L94.6933 54.3597L96.2239 55.2319L98.3295 50.6979Z",
    fill: "#5B8745"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9006 52.0147C98.9006 53.2215 98.1695 54.6218 97.2673 55.1443C96.3638 55.6668 95.6327 55.1127 95.6327 53.9059C95.6327 52.7004 96.3638 51.2988 97.2673 50.7763C98.1695 50.2551 98.9006 50.8092 98.9006 52.0147Z",
    fill: "#5D8E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9109 27.7188C75.6023 27.6146 71.4979 32.981 69.4704 36.9883C66.9062 42.0557 66.5256 48.8744 70.007 53.5908C67.5469 48.1106 67.3935 42.906 69.8866 37.5986C72.1496 32.7807 76.2472 28.8927 81.9109 27.7188Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8145 5.63056C37.5059 5.52496 33.3987 10.8927 31.3726 14.8987C28.8083 19.9661 28.4277 26.7848 31.9106 31.5012C29.449 26.021 29.2943 20.8178 31.7901 15.509C34.0518 10.6911 38.1493 6.80313 43.8145 5.63056Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1298_1000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 96,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabricRoll);
export default __webpack_public_path__ + "static/media/fabric-roll.98d2d5cf20b3e62e308ba010788614cf.svg";
export { ForwardRef as ReactComponent };